import { useMutation, useQueryClient } from 'react-query';
import { toast } from 'sonner';

import { QueryEntity } from '../types';
import { APIBaseChronos } from '@/api/hosts';
import useGetFetchConfig, { FetchMethod } from '@/api/useGetFetchConfig';

export const useImportSampleMatter = () => {
  const { getFetchConfig } = useGetFetchConfig();
  const queryClient = useQueryClient();

  const importSampleMatter = async (): Promise<{ matterId: string }> => {
    const fetchConfig = getFetchConfig({
      method: FetchMethod.POST,
    });

    const response = await fetch(`${APIBaseChronos}/api/matters/sample/import`, fetchConfig);
    if (!response.ok) {
      throw new Error('Error importing sample matter');
    }
    return response.json();
  };

  return useMutation({
    onError: (error) => {
      console.error('Error importing sample matter:', error);
      toast.error('Error importing sample matter');
    },
    mutationFn: importSampleMatter,
    onSuccess: () => {
      queryClient.invalidateQueries([QueryEntity.Matters]);
    },
  });
};
